window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('deals_cat')) return

  // 店舗リストの開閉（別の用途）
  const shopItems = document.querySelectorAll('.shop_list > li')
  shopItems.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-current')
    })
  })

  // カテゴリタブ切り替え
  const tabs = document.querySelectorAll('.child_cat_list li')
  const lists = document.querySelectorAll('.deals_list')

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      const { termId } = this.dataset

      tabs.forEach((li) => li.classList.remove('is-current'))
      this.classList.add('is-current')

      lists.forEach((list) => {
        list.style.display = list.dataset.termId === termId ? 'flex' : 'none'
      })
    })
  })

  const seeMoreBtn = document.getElementById('seeMoreBtn')

  if (seeMoreBtn) {
    seeMoreBtn.addEventListener('click', function (e) {
      e.preventDefault()

      const parentCat02 = this.dataset.parentCat
      const currentTab = document.querySelector('.child_cat_list li.is-current')
      const childCat = currentTab?.dataset.termId

      if (!childCat) return

      const url = new URL('/deals/', window.location.origin)
      url.searchParams.set('parent_cat', parentCat02)
      url.searchParams.set('child_cat', childCat)
      url.searchParams.set('deals_condition', '')
      url.searchParams.set('s', '')
      url.searchParams.set('post_type', 'deals')

      window.location.href = url.toString()
    })
  }
})
